import type * as api from '@gitbook/api-client';
import { BreadcrumbItem } from '@gitbook/spine-react';

import { SpaceEditableIcon, SpaceIcon } from '../..';
import { SpaceTitle } from '../SpaceTitle';

/**
 * Breadcrumb item to display a space.
 */
export function SpaceBreadcrumbItem(props: {
    space: api.Space;
    iconOnly: boolean;
    editable: boolean;
}) {
    const { space, iconOnly } = props;
    const editable = props.editable && space.permissions.admin;
    return (
        <BreadcrumbItem
            iconOnly={iconOnly}
            label={space.title}
            href={{
                screen: {
                    type: 'space',
                    space: space.id,
                    organization: space.organization,
                    changeRequest: undefined,
                    revision: undefined,
                    mode: undefined,
                },
            }}
            icon={
                editable ? (
                    <SpaceEditableIcon space={space} withBackground={false} />
                ) : (
                    <SpaceIcon space={space} withBackground={false} />
                )
            }
        >
            <div className="-mx-1 flex">
                <SpaceTitle space={space} editable={editable} size="small" />
            </div>
        </BreadcrumbItem>
    );
}
